export const LIST_WITH_COURSES_AND_INTERNSHIPS_PAGE = "/it-courses-search";
export const LANGUAGES_TOP_PAGE = "/languages-top";
